import React from "react";
import { __experimentalNumberControl as NumberControl } from "@wordpress/components";
import { Icon } from "@wordpress/components";

const ENABLE_CLEAR_BTN = false;

export const CustomNumberControl = ({ value, setValue, label, ...props }) => {
  const handleClear = (e) => {
    e.stopPropagation();
    setValue(0);
  };

  return (
    <div style={{ position: "relative" }}>
      <NumberControl
        value={value == 0 ? null : value}
        __next40pxDefaultSize
        __nextHasNoMarginBottom
        label={label}
        onChange={setValue}
        showArrows={false}
        adornment={<span style={{ color: "blue" }}>PX</span>}
        isShiftStepEnabled={true}
        shiftStep={10}
        style={{ background: "transparent", ...props?.style }}
        suffix={
          <div style={{
            display: "flex",
            alignItems: "center",
            position: "relative",
            width: ENABLE_CLEAR_BTN ? "43px" : "23px" 
          }}>
            {value > 0 && ENABLE_CLEAR_BTN && (
              <button
                onClick={handleClear}
                style={{
                  border: "none",
                  background: "transparent",
                  cursor: "pointer",
                  padding: "0",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  color: "#757575",
                  width: "16px",
                  height: "16px",
                  position: "absolute",
                  left: "0"
                }}
                aria-label="Clear value"
              >
                <Icon icon="dismiss" size={16} />
              </button>
            )}
            <div
              style={{
                marginRight: "10px",
                color: "#3858E9",
                fontSize: "16px!important",
                position: "absolute",
                right: "0",
                paddingBottom: ".3em",
              }}
            >
              px
            </div>
          </div>
        }
        {...props}
      />
    </div>
  );
};